var styles = {"radioBoxWrapper":"VBG__DS__radio-box-module__zdjGd","showIndicator":"VBG__DS__radio-box-module__kSbbB","checkmarkWrapper":"VBG__DS__radio-box-module__8a2yO","dark":"VBG__DS__radio-box-module__9S4-3"};

export { styles as default };
